import React, { useState, useEffect } from "react";

const advantages = [
  {
    title: "± 1 degree accuracy",
    description: "For Gold Standard of Measurement",
    color: "text-blue",
  },
  {
    title: "Measure Hands Free with Auto Measure",
    description: "Intervention free measurement",
    color: "text-blue",
  },
  {
    title: "Measures everything from extremity, to finger",
    description: "Replaces old All types of Goniometers",
    color: "text-blue",
  },
  {
    title: "Pivot free measurement",
    description:
      "Go Neo automatically detects the pivot of joint and calculates precise ROM",
    color: "text-blue",
  },
  {
    title: "Measure Cervical, lumber, thoracic Joint",
    description: "Replaces need for multiple Inclinometers",
    color: "text-blue",
  },
  {
    title: "Save readings",
    description:
      "Save 6 readings at a time to note later or show instantaneous betterment",
    color: "text-blue",
  },
];

function Advantages() {
  const [isLargeScreen, setIsLargeScreen] = useState(() =>
      window.matchMedia("(min-width: 1280px)").matches
    );
     useEffect(() => {
        const mediaQuery = window.matchMedia("(min-width: 1280px)");
        const handleChange = (e) => setIsLargeScreen(e.matches);
        mediaQuery.addEventListener("change", handleChange);
    
        return () => {
          mediaQuery.removeEventListener("change", handleChange);
        };
      }, []);
  return (
    <>{isLargeScreen&&
      <div className="bg-gray-light m-0 p-0">
      {/* Header Section */}
      <div className="bg-dark-blue m-0 text-white upy-3">
        <p className="text-center fw-bold ufs-7 m-0">GoNeo ADVANTAGES</p>
      </div>

      {/* Advantages Section */}
      <div className="d-flex flex-wrap justify-content-center m-0  upy-5">
        {advantages.map((adv, index) => (
          <div
            className="d-flex flex-column align-items-center justify-content-center box-shadow text-center uh-60 uw-90 br-5 um-2 up-3"
           
            key={index}
          >
            <p className={`m-0 fw-bold ufs-6 ${adv.color}`}>{adv.title}</p>
            <p className="m-0 text-gray ufs-5 text-center">{adv.description}</p>
          </div>
        ))}
      </div>
    </div>
    }{!isLargeScreen&&
      <div className="bg-gray-light m-0 p-0">
      {/* Header Section */}
      <div className="bg-dark-blue m-0 text-white upy-3">
        <p className="text-center fw-bold ufs-14 m-0">GoNeo ADVANTAGES</p>
      </div>

      {/* Advantages Section */}
      <div className="d-flex flex-wrap justify-content-center m-0 py-2">
        {advantages.map((adv, index) => (
          <div
            className="d-flex flex-column align-items-center justify-content-center box-shadow text-center  w-75 br-20 um-5 upy-20 upx-10"
           
            key={index}
          >
            <p className={`m-0 fw-bold ufs-14 ${adv.color}`}>{adv.title}</p>
            <p className="m-0 text-gray ufs-12 text-center">{adv.description}</p>
          </div>
        ))}
      </div>
    </div>
    
    }
    
    </>
    
  );
}

export default Advantages;
